import { render, staticRenderFns } from "./QSCInspectionListResult.vue?vue&type=template&id=70855ab4&scoped=true&"
import script from "./QSCInspectionListResult.vue?vue&type=script&lang=js&"
export * from "./QSCInspectionListResult.vue?vue&type=script&lang=js&"
import style0 from "./QSCInspectionListResult.vue?vue&type=style&index=0&id=70855ab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70855ab4",
  null
  
)

export default component.exports